"use client";

import { Provider } from "jotai";
import { ReactNode } from "react";

// https://github.com/Nitoel/nitoel/issues/2131
// 超大事
// key を変えると Provider（jotai の store）が作り直され、atom が初期値に戻る。
// サーバーでは 1 request につき 1 Provider、クライアントでは画面遷移ごとに 1 Provider になるよう、
// キーは _app が usePageTransition で振る（shallow な遷移では変えない）
export default function Providers({ storeKey, children }: { storeKey: string; children: ReactNode }) {
  return <Provider key={storeKey}>{children}</Provider>;
}
